import { FunctionComponent } from 'react';
import styled from 'styled-components';

// const Separator: FunctionComponent = () => (
//   <span className="sep">|</span>
// )

const descriptionText = "Two longtime friends discuss what indie video games they're playing."
const scheduleText = "New episodes release every other Tuesday."

const UnstyledHeader: FunctionComponent = (props) => (
  <header {...props}>
    {/* desktop display */}
    <div className="header-container mobile-hide">
      <div className="name-and-description">
        <h1>Emmi &amp; Annie <br /> Talk Indie</h1>
        <p>
          {descriptionText}
          <br />
          {scheduleText}
        </p>
      </div>
      <img src={`${process.env.PUBLIC_URL}/sprites.png`} alt='' />
    </div>

    {/* mobile display */}
    <div className="header-container mobile-show">
      <div className="name-and-logo">
        <img src={`${process.env.PUBLIC_URL}/sprites.png`} alt='' />
        <h1>Emmi &amp; Annie <br /> Talk Indie</h1>
      </div>
      <p>
        {descriptionText}{' '}{scheduleText}
      </p>
    </div>
  </header>
);

const StyledHeader = styled(UnstyledHeader)`
  align-items: center;
  background-color: #FFC300;
  display: flex;
  justify-content: center;
  text-align: right;
  min-height: max(30vh, 35%);

  @media screen and (min-width: 800px) {
    min-height: max(50vh, 50%);
  }

  // desktop display
  .mobile-hide {
    display: none;

    @media screen and (min-width: 800px) {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
      width: 85%;

      img {
        height: 35%;
        width: 35%;
      }
    }
  }

  // mobile display
  .mobile-show {
    @media screen and (min-width: 800px) {
      display: none;
    }

    align-items: center;
    display: flex;
    flex-direction: column;
    width: 85%;
    margin: 2% 4%;

    .name-and-logo {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-evenly;
    }

    h1 {
      text-align: center;
      font-size: 1.5em;
    }

    img {
      height: 100px;
      width: 100px;
    }

    p {
      text-align: justify;
      width: 90%;
      word-spacing: -1.5px;
    }
  }

  h1 {
    font-family: "cooper-black-std", serif;

    @media screen and (min-width: 800px) {
      text-align: right;
      font-weight: 400;
      font-style: normal;
      font-size: 4em;
      text-align: right;
      line-height: 1em;
    }
  }

  p {
    font-weight: 600;
    font-style: italic;

    @media screen and (min-width: 800px) {
      font-size: 1.5em;
    }
  }
`;

export const Header: FunctionComponent = (props) => <StyledHeader {...props} />;
